const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} Data structure that contains category data mapping L1s/L2s/L3s
 */
export function getCategoriesTree() {
    return ChairishContext.CATEGORIES_TREE;
}

/**
 * @returns {string} The type code for "declined"
 */
export function getDeclinedTypeCode() {
    return ChairishContext.DECLINED_CODE;
}

/**
 * @returns {string} Warning text to display in a confirmation modal before deleting a product
 */
export function getDeleteWarningText() {
    return ChairishContext.DELETE_WARNING_TEXT;
}

/**
 * @returns {string} The string that labels editable field suggestions
 */
export function getEditableSuggestionsLabel() {
    return ChairishContext.EDITABLE_SUGGESTIONS_LABEL;
}

/**
 * @returns {string} The type code for "incomplete"
 */
export function getIncompleteTypeCode() {
    return ChairishContext.INCOMPLETE_CODE;
}

/**
 * @returns {Object} A data structure used to represent "meta" information for the listing flow
 */
export function getMetaObject() {
    return ChairishContext.META || {};
}

/**
 * @param {string} fieldName The name fo the field to get the endpoint for
 * @returns {string|undefined}
 */
export function getChoiceTreeEndpointByFieldName(fieldName) {
    return ChairishContext.CHOICE_PRODUCT_SEARCH_URLS[fieldName];
}

/**
 * @returns {string} A URL to the "My Listings" page
 */
export function getMyListingsUrl() {
    return ChairishContext.MY_LISTINGS_URL;
}

/**
 * @returns {Object} A data structure used to represent "product" information for the listing flow
 */
export function getProductObject() {
    return ChairishContext.PRODUCT || {};
}

/**
 * @param {string} discount Amount of sale discount
 * @returns {string} The string that indicates sale discount
 */
export function getSaleDiscountText(discount) {
    return ChairishContext.SALE_DISCOUNT_TEXT + discount + ChairishContext.SALE_DISCOUNT_SUFFIX;
}

/**
 * @param {string} price Amount of sale price
 * @returns {string} The string that indicates sale price
 */
export function getSalePriceText(price) {
    return ChairishContext.SALE_PRICE_TEXT + price;
}

/**
 * @returns {string} The string that labels field suggestions
 */
export function getSuggestionsLabel() {
    return ChairishContext.SUGGESTIONS_LABEL;
}

/**
 * @param {string} fieldName The name of the field to get tree choices for
 * @returns {Array.<Choice>} Array of choices that can be used for various product attributes
 */
export function getTreeChoicesByFieldName(fieldName) {
    return ChairishContext[`${fieldName.toUpperCase()}_TREE`];
}

/**
 * @returns {string} The text to display when a user attempts to leave the page without saving
 */
export function getUnsavedChangesConfirmationText() {
    return ChairishContext.UNSAVED_CHANGES_CONFIRMATION;
}

/**
 * @param {Object} metaObj The object to set in the context
 */
export function setMetaObject(metaObj) {
    ChairishContext.META = metaObj;
}

/**
 * @param {Object} productObj The object to set in the context
 */
export function setProductObject(productObj) {
    ChairishContext.PRODUCT = productObj;
}

/**
 * @returns {string} The URL to use when looking up an account
 */
export function getAccountLookupUrl() {
    return getMetaObject().account_lookup_url;
}

/**
 * @returns {Array.<string>} State attribute values that require more info to be submitted via a modal
 */
export function getAttrValuesWithModals() {
    return [getDeclinedTypeCode(), getIncompleteTypeCode()];
}
